import {createBrowserRouter} from 'react-router';
import {MainPage} from '../pages/MainPage';
import {Layout} from './layout';
import {CatalogPage} from '../pages/catalog/CatalogPage';
import {FaqPage} from '../pages/FaqPage';
import {CarFiltersPage} from '../pages/CarFiltersPage';
import {BrakePadsPage} from '../pages/BrakePadsPage';
import {WiperBladesPage} from '../pages/WiperBladesPage';
import {AboutUsPage} from '../pages/AboutUsPage';
import {ProductPage} from '../pages/productPage/ProductPage';
import {ContactsPage} from '../pages/contactsPage/ContactsPage';
import {NotFound} from '../pages/notFound/NotFound';
import {ArticlePage} from '../pages/article/ArticlePage';
import {Feedback} from '../pages/feedback/Feedback';
import {Login} from '../pages/loginPage/Login';
import {ProtectedRoute} from './ProtectedRoute';
import {SignUp} from '../pages/signUpPage/SignUp';
import {Profile} from '../pages/Profile';
import PolicyPage from '../pages/policy/PolicyPage';
export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <MainPage />,
      },
      {
        path: '/catalog',
        element: <CatalogPage />,
      },
      {
        path: '/product/:productId/:engineId?',
        element: <ProductPage />,
      },
      {
        path: '/faq',
        element: <FaqPage />,
      },
      {
        path: '/car-filters/:filter?',
        element: <CarFiltersPage />,
      },
      {
        path: '/brake-pads/:pad?',
        element: <BrakePadsPage />,
      },
      {
        path: '/wiper-blades/:wiper?',
        element: <WiperBladesPage />,
      },
      {
        path: '/about-us',
        element: <AboutUsPage />,
      },
      {
        path: '/contacts',
        element: <ContactsPage />,
      },
      {
        path: '/article/:articleId',
        element: <ArticlePage />,
      },
      {
        path: '/feedback',
        element: <Feedback />,
      },
      {
        path: '/login',
        element: <Login />,
      },
      {path: '/signUp', element: <SignUp />},
      {
        path: '/profile',
        element: <ProtectedRoute element={<Profile />} />,
      },
      {
        path: '/policy',
        element: <PolicyPage />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);
